import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, ShoppingBag } from "lucide-react";
import { CartDrawer } from "@/components/shop/CartDrawer";
import logo from "@/assets/logo.png";

const navItems = [
  { label: "Hjem", href: "/" },
  { label: "Om oss", href: "/om-oss" },
  { label: "Tjenester", href: "/tjenester" },
  { label: "Arrangementer", href: "/arrangementer" },
  { label: "Kontakt", href: "/kontakt" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  const isActive = (href: string) => {
    if (href === "/") return location.pathname === "/";
    return location.pathname.startsWith(href);
  };

  return (
    <header className="sticky top-0 z-50 border-b border-border/50 bg-background/80 backdrop-blur-lg">
      <nav className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3">
        <div className="flex items-center">
          <Link
            to="/"
            className="flex items-center"
            onClick={() => setOpen(false)}
            aria-label="Håp Naturlab – til forsiden"
          >
            <img src={logo} alt="" aria-hidden="true" className="h-14 w-auto" width={56} height={56} />
          </Link>
        </div>

        {/* Desktop nav */}
        <div className="hidden items-center gap-1 lg:flex">
          <ul className="flex items-center gap-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link
                  to={item.href}
                  className={`rounded-full px-4 py-2 font-body text-sm font-medium transition-colors duration-200 ${
                    isActive(item.href)
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:text-foreground hover:bg-secondary"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
          </ul>
          <Link
            to="/nettbutikk"
            className="ml-4 inline-flex items-center gap-2 rounded-full bg-primary px-5 py-2.5 font-body text-sm font-semibold text-primary-foreground shadow-md transition-all duration-300 hover:opacity-90 hover:-translate-y-0.5"
          >
            <ShoppingBag className="h-4 w-4" />
            Nettbutikk
          </Link>
          <CartDrawer />
        </div>

        {/* Mobile: cart + toggle */}
        <div className="flex items-center gap-2 lg:hidden">
          <CartDrawer />
          <button
            className="rounded-full p-2 transition-colors hover:bg-secondary"
            onClick={() => setOpen(!open)}
            aria-label="Toggle menu"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {open && (
        <div className="animate-fade-in border-t border-border/50 bg-background px-6 py-4 lg:hidden">
          <ul className="space-y-1">
            {navItems.map((item) => (
              <li key={item.href}>
                <Link
                  to={item.href}
                  onClick={() => setOpen(false)}
                  className={`block rounded-xl px-4 py-3 font-body text-sm font-medium transition-colors ${
                    isActive(item.href)
                      ? "bg-primary text-primary-foreground"
                      : "text-muted-foreground hover:bg-secondary hover:text-foreground"
                  }`}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/nettbutikk"
                onClick={() => setOpen(false)}
                className="mt-2 flex items-center gap-2 rounded-xl bg-primary px-4 py-3 font-body text-sm font-semibold text-primary-foreground"
              >
                <ShoppingBag className="h-4 w-4" />
                Nettbutikk
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
};

export default Navbar;
